import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import _ from "lodash";

const RequestDataContext = createContext();

export function RequestDataHolder({ settings, children }) {
  const [requestData, setRequestData] = useState({});

  const saveRequestData = (updatedData) => {
    setRequestData((prevData) => ({
      ...prevData,
      ...updatedData,
    }));
  };

  return (
    <RequestDataContext.Provider
      value={{
        requestData: requestData,
        saveRequestData: saveRequestData,
      }}
    >
      {children}
    </RequestDataContext.Provider>
  );
}

RequestDataHolder.propTypes = {
  children: PropTypes.node.isRequired,
  settings: PropTypes.object,
};

export const RequestDataConsumer = RequestDataContext.Consumer;

export default RequestDataContext;
